// https.js
import axios from 'axios';
import qs from 'qs';
import { appName, apiServer } from '@/connect';
import { clearAuthSession, hasValidAuthSession } from '@/store/auth';
import { alert } from '@/utils/vue3-simple-alert';
import { gotoUserLogin, goto403Page } from './to-page.js';

let access_ouid = '';
let access_guid = '';
let access_role = '';
let access_type = '';
let access_uid = '';
let access_id = '';
let access_token = '';
let expire_time = '';

let instance = null;

export const createServer = (_store, _router) => {
	const appname = appName();
	const server_url = apiServer();
	const msgbox = alert;
	const auth = _store.state.settings.auth;

	console.log(`https, create-server, appname=${appname}`);
	console.log(`https, create-server, server_url=${server_url}`);
	console.log(`https, create-server, isLogin=${auth.isLogin}`);

	const has_valid_session = hasValidAuthSession(_store);
	access_ouid = has_valid_session ? auth.accessOUID : '';
	access_guid = has_valid_session ? auth.accessGUID : '';
	access_role = has_valid_session ? auth.accessRole : '';
	access_type = has_valid_session ? auth.accessType : '';
	access_uid = has_valid_session ? auth.accessUID : '';
	access_id = has_valid_session ? auth.accessId : '';
	access_token = has_valid_session ? auth.accessToken : '';
	expire_time = has_valid_session ? auth.expTime : '';

	console.log(
		`https, create-server, has_access_token=${Boolean(access_token)}`
	);

	instance = axios.create({
		baseURL: server_url,
		timeout: 30000,
		cache: false,
		withCredentials: false, // CORS 問題：不帶認證(cookie)設為 false 避免與後端 wildcard '*' 衝突
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'Cache-Control': 'no-cache',
		},
	});

	instance.interceptors.request.use(
		config => {
			const auth = _store.state.settings.auth;
			const is_login = hasValidAuthSession(_store);
			access_ouid = is_login ? auth.accessOUID : '';
			access_uid = is_login ? auth.accessUID : '';
			access_id = is_login ? auth.accessId : '';
			access_token = is_login ? auth.accessToken : '';
			expire_time = is_login ? auth.expTime : '';

			console.log(`https, interceptors, is_login=${is_login}`);
			// console.log(`https, interceptors, access_ouid=${access_ouid}`);
			// console.log(`https, interceptors, access_guid=${access_guid}`);
			// console.log(`https, interceptors, access_role=${access_role}`);
			// console.log(`https, interceptors, access_type=${access_type}`);
			console.log(
				`https, interceptors, has_access_token=${Boolean(access_token)}`
			);

			// console.log(
			// 	`https, interceptors, config.headers=${JSON.stringify(config.headers)}`
			// );

			config.headers['payload'] = `{ "payload": { "id": "${
				access_id || ''
			}", "uid": "${access_uid || ''}", "ouid": "${
				access_ouid || ''
			}", "token": "${
				access_token || ''
			}", "exptime": "${expire_time || ''}" }}`;

			return config;
		},
		error => {
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		response => {
			return response;
		},
		async error => {
			const { response } = error;

			if (response) {
				console.log(
					`https, error, response.data=${JSON.stringify(response.data) || ''}`
				);
				console.log(`https, error, response.status=${response.status}`);
				await errorHandler(
					_store,
					_router,
					response.status,
					response.statusText
				);
				return Promise.reject(error);
			} else {
				if (!window.navigator.onLine) {
					msgbox('網路出了點問題，請重新整理');
				} else {
					return Promise.reject(error);
				}
			}
		}
	);

	return server_url;
};

export const req = (method, url, data) => {
	const server_url = apiServer();
	//const msgbox = alert;
	// msgbox(server_url);

	method = method == null ? 'get' : method.toLowerCase();
	console.log(`https, server_url=${server_url}, method=${method}, url=${url}`);

	if (method === 'post') {
		if (typeof FormData !== 'undefined' && data instanceof FormData) {
			return instance.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				onUploadProgress:
					typeof data.onUploadProgress === 'function'
						? data.onUploadProgress
						: undefined,
			});
		}
		// console.log('https, get in post===' + method);
		return instance.post(url, qs.stringify(data), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		});
	} else if (method === 'get') {
		return instance.get(url, data);
	} else if (method === 'delete') {
		return instance.delete(url, data);
	} else if (method === 'put') {
		return instance.put(url, data);
	} else {
		console.log('https, unknown method=' + method);
		return Promise.reject('unknown error!');
	}
};

export const reqJson = (url, data = {}, config = {}) =>
	instance.post(url, data, {
		...config,
		headers: {
			...(config.headers || {}),
			'Content-Type': 'application/json;charset=UTF-8',
		},
	});

const errorHandler = async (_store, _router, status, msg) => {
	const currentRoute = _router.currentRoute.value;
	const msgbox = alert;

	switch (status) {
		case 400:
			console.log(`請求資料驗證失敗: ${msg}`);
			if (currentRoute.name === 'signin') {
				msgbox('登入失敗');
			}
			break;
		case 401:
			console.log(`未登入或認證過期: ${msg}`);
			await clearAuthSession(_store);
			if (currentRoute.name === 'signin') {
				console.log(
					`https, No need for msgbox, as login will redirect to the homepage`
				);
			} else {
				msgbox('未登入或認證過期，請重新登入');
				setTimeout(() => {
					gotoUserLogin();
				}, 1500);
			}
			break;
		case 403:
			console.log(`https, 權限不足: ${msg}`);
			setTimeout(() => {
				goto403Page();
			}, 1500);
			break;
		case 404:
			console.log(`https, 請求失敗: ${msg}`);
			break;
		case 500:
			console.log(`https, 伺服器錯誤: ${msg}`);
			break;
		default:
			console.log(`https, 沒有攔截到的錯誤: ${msg}`);
			break;
	}
};
